// Configuración de acciones masivas disponibles
// option: valor que se envía al backend

export const accionesDisponibles = [
  {
    id: 'habilitar_gps',
    icon: '📍',
    titulo: 'Habilitar GPS',
    descripcion: 'Activa el campo GPS para los clientes seleccionados',
    filtros: ['todos', 'empleado'],
    option: 1,
  },
  {
    id: 'deshabilitar_gps',
    icon: '🚫',
    titulo: 'Deshabilitar GPS',
    descripcion: 'Desactiva el campo GPS para los clientes seleccionados',
    filtros: ['todos', 'empleado'],
    option: 0,
  },
  // Agregar más acciones acá:
  // {
  //   id: 'cambiar_lista_precios',
  //   icon: '💰',
  //   titulo: 'Cambiar Lista de Precios',
  //   descripcion: 'Asigna una lista de precios a los clientes',
  //   filtros: ['todos', 'empleado', 'zona'],
  //   option: null, // requiere parámetro extra
  // },
];
